export function alphabetize(a: string, b: string): -1 | 1 | 0 {
  if (a < b) return -1;
  if (a > b) return 1;
  return 0;
}
